import { Injectable } from '@angular/core';
import SidePanel from './side-panel';

@Injectable({
  providedIn: 'root'
})
export class ActiveSidePanelService {

  sidePanel: SidePanel<any>;

  constructor() { }

  set(sidePanel: SidePanel<any>) {
    this.sidePanel = sidePanel;
  }

  close(returnData?: any) {
    if (this.sidePanel) {
      this.sidePanel.panel.close(returnData);
    }
  }
}
